import { configureStore } from "@reduxjs/toolkit";
// Or from '@reduxjs/toolkit/query/react'
import { setupListeners } from "@reduxjs/toolkit/query";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

import playerSlice, { PlayerState } from "./features/player/playerSlice";
import tournoiSlice, { TournoiState } from "./features/tournoi/tournoiSlice";
import sessionSlice, { SessionState } from "./features/session/sessionSlice";
import matchsSlice, { MatchsState } from "./features/matchs/matchsSlice";
import globalNotificationSlice from "./features/globalNotification/globalNotificationSlice";
import { firebaseErrorLogger } from "./firebaseErrorLogger";

export const store = configureStore({
  reducer: {
    player: playerSlice,
    tournoi: tournoiSlice,
    session: sessionSlice,
    matchs: matchsSlice,
    globalNotification: globalNotificationSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(firebaseErrorLogger),
});

export type RootState = {
  player: PlayerState;
  tournoi: TournoiState;
  session: SessionState;
  matchs: MatchsState;
  globalNotification: {
    open: boolean;
    message: string;
    severity: "success" | "error" | "info" | "warning";
    autoHideDuration: number;
  };
};
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch; // Export a hook that can be reused to resolve types
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch);
